var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"content":_vm.label,"effect":"light","placement":"bottom","enterable":false}},[_c('el-button',{staticClass:"table-action-button",attrs:{"icon":_vm.buttonIcon,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.clickFunction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }